'use strict';

var pill = {};

exports.__exports = pill;
//# sourceMappingURL=pill2.cjs.map
